import http from "@/utils/http";
//查询服务对象
export const queryServiceObjects= () => http.get('/nonlogin/serviceObject/queryServiceObjectList.htm');
//查询办理途径
export const queryServiceWays= () => http.get('/nonlogin/transactWay/queryTransactWayList.htm');
//查询事项类型
export const queryServiceTypes= () => http.get('/nonlogin/elobby/type/queryTypes.htm');
//查询服务部门
export const queryServiceDepts= () => http.get('/nonlogin/serviceHandleCenter/queryDirectDeptList.htm');
//查询服务列表
export const queryServices= (params) => http.get('/nonlogin/serviceHandleCenter/queryServicesWithPageByCondition.htm',params);
//查询服务
export const queryService= id => http.get(`/elobby/service/mobile/introduction/${id}.htm`);
//查询服务扩展配置
export const queryServiceExtends = id => http.get(`/nonlogin/elobby/service/introduction/extends.htm`,{serviceId:id})
//收藏服务
export const favService = id => http.get(`/elobby/${id}/fav/yes.htm`)
//取消收藏服务
export const cancelFavService = id => http.get(`/elobby/${id}/fav/no.htm`)
//办理服务次数加1
export const increaseHandle = id => http.get(`elobby/handle/inc/${id}.htm`)
